// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  background: #0000006e;
}

.bg-grey { 
  background-color: #bbbbbb !important;
}

.user-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

@media (min-width: 992px) {
  .modal-lg, .modal-xl {
      --vz-modal-width: 960px !important;
  }
}

.user-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s;
  min-width: 200px;
}

.user-card:hover {
  background: #f5f5f5;
}

.user-card.selected {
  border: 2px solid #007bff;
  background: rgba(0, 123, 255, 0.1);
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.user-info {
  flex-grow: 1;
}

.select-icon {
  font-size: 18px;
  font-weight: bold;
}




#quoteDetail .container {
  width: 80%;
  margin: auto;
  padding: 20px;
  border: 1px solid #000;
}
#quoteDetail .header, .footer {
  text-align: center;
  font-weight: bold;
  page-break-before: always;

}
#quoteDetail .details, .terms {
  margin-top: 20px;
}
#quoteDetail table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}
#quoteDetail table, th, td {
  border: 1px solid black;
  padding: 8px;
  text-align: left;
}
#quoteDetail .right {
  text-align: right;
}

#quoteDetail td,#quoteDetail th,#quoteDetail p,#quoteDetail div {
  letter-spacing: 0.5px; /* Adjust if necessary */
  word-spacing: 1px;
  white-space: normal;
}


.form-check-input {
  width: 50px;
  height: 24px;
  background-color: #ccc;
  border-radius: 24px;
  position: relative;
  margin-right: 3px;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  transition: background-color 0.3s;
  cursor: pointer;
}

.form-check-input::before {
  content: '';
  position: absolute;
  width: 18px;
  height: 18px;
  background: #fff;
  border-radius: 50%;
  top: 3px;
  left: 3px;
  transition: transform 0.3s;
}

.form-check-input:checked {
  background-color: #4caf50;
}

.form-check-input:checked::before {
  transform: translateX(20px);
}

.form-check {
  display: flex;
  align-items: center;
  gap: 1px;
  margin-right: 30px !important;
}

.form-check-label {
  margin-bottom: 0;
  font-weight: 500;
  margin-top: 5px;

}

.navbar-menu {
  background: #1b1b1f;
}

.scanner-box {
  width: 100%;
  max-width: 800px;
  height: 350px;
  border: 2px solid #333;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  background: #000;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .scanner-box {
    height: 160px;
  }
}


/* Page Wrapper Padding with / without Horizontal Menu */
.page-wrapper.has-horizontal-menu {
  padding-top: 122px !important;
}

.page-wrapper.no-menu-padding {
  padding: 65px 0 0 !important;
}

@media (max-width: 991.96px) {
  .page-wrapper.has-horizontal-menu {
    padding-top: 122px !important;
    margin-left: 0 !important;
  }
  .page-wrapper.no-menu-padding {
    padding: 65px 0 0 !important;
    margin-left: 0 !important;
  }
}

@media (max-width: 768px) {
  .page-wrapper.has-horizontal-menu {
    padding-top: 118px !important;
  }
}

.slide-form {
  max-width: 0;
  opacity: 0;
  overflow: hidden;
  transition: all 0.35s ease;
}

.slide-form.open {
  max-width: 100%;
  opacity: 1;
}


.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}


.dropdown-fixed {
    margin-top: 0 !important;
    top: 100% !important;
    left: 0;
    transform: translateY(2px);
}


/* ============================================================
   HORIZONTAL SUB-NAVIGATION (DESKTOP & RESPONSIVE)
   ============================================================ */

#horizontal-menu,
.horizontal-menu-wrapper {
  display: block !important;
  position: fixed !important;
  top: 65px !important;
  right: 0 !important;
  height: 52px !important;
  background: #ffffff !important;
  border-bottom: 1px solid #e6eaed !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04) !important;
  z-index: 998 !important;
  margin: 0 !important;
  padding: 0 16px !important;
  box-sizing: border-box !important;
  visibility: visible !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  transition: left 0.3s ease, width 0.3s ease;
}

/* Desktop layout (width > 991.96px): offset by left vertical sidebar */
@media (min-width: 992px) {
  #horizontal-menu,
  .horizontal-menu-wrapper {
    left: 252px !important;
    width: calc(100% - 252px) !important;
  }

  .mini-sidebar #horizontal-menu,
  .mini-sidebar .horizontal-menu-wrapper {
    left: 80px !important;
    width: calc(100% - 80px) !important;
  }
}

/* Responsive mode (Tablets & Mobile <= 991.96px):
   Ensure menu is fully visible across full screen width under header */
@media (max-width: 991.96px) {
  #horizontal-menu,
  .horizontal-menu-wrapper,
  .sidebar-horizontal {
    display: block !important;
    position: fixed !important;
    top: 65px !important;
    left: 0 !important;
    right: 0 !important;
    width: 100% !important;
    margin-left: 0 !important;
    visibility: visible !important;
    opacity: 1 !important;
    padding: 0 12px !important;
  }
}

@media (max-width: 768px) {
  #horizontal-menu,
  .horizontal-menu-wrapper,
  .sidebar-horizontal {
    height: 48px !important;
    padding: 0 8px !important;
  }
}

/* Inner structure of Horizontal Menu */
#horizontal-menu .sidebar-menu,
.horizontal-menu-wrapper .sidebar-menu {
  height: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
}

#horizontal-menu .horizontal-scroll-wrapper,
.horizontal-menu-wrapper .horizontal-scroll-wrapper {
  width: 100% !important;
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
  overflow: hidden !important;
  position: relative !important;
}

/* Horizontally scrollable pill list */
#horizontal-menu .horizontal-scroll-menu,
.horizontal-menu-wrapper .horizontal-scroll-menu {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  align-items: center !important;
  gap: 8px !important;
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  padding: 4px 2px !important;
  list-style: none !important;
  overflow-x: auto !important;
  -webkit-overflow-scrolling: touch !important;
  scrollbar-width: none !important; /* Firefox */
}

#horizontal-menu .horizontal-scroll-menu::-webkit-scrollbar,
.horizontal-menu-wrapper .horizontal-scroll-menu::-webkit-scrollbar {
  display: none !important; /* Chrome / Safari / Edge */
}

#horizontal-menu .horizontal-scroll-menu li,
.horizontal-menu-wrapper .horizontal-scroll-menu li {
  flex-shrink: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  white-space: nowrap !important;
}

/* Pill buttons */
#horizontal-menu .horizontal-scroll-menu .btn,
.horizontal-menu-wrapper .horizontal-scroll-menu .btn {
  display: inline-flex !important;
  align-items: center !important;
  padding: 6px 14px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  line-height: 1.2 !important;
  border-radius: 6px !important;
  white-space: nowrap !important;
  transition: all 0.2s ease !important;
  text-decoration: none !important;
}

#horizontal-menu .horizontal-scroll-menu .btn i,
.horizontal-menu-wrapper .horizontal-scroll-menu .btn i {
  font-size: 15px !important;
  margin-right: 6px !important;
}

@media (max-width: 768px) {
  #horizontal-menu .horizontal-scroll-menu {
    gap: 6px !important;
  }

  #horizontal-menu .horizontal-scroll-menu .btn,
  .horizontal-menu-wrapper .horizontal-scroll-menu .btn {
    padding: 5px 10px !important;
    font-size: 12px !important;
  }

  #horizontal-menu .horizontal-scroll-menu .btn i,
  .horizontal-menu-wrapper .horizontal-scroll-menu .btn i {
    font-size: 14px !important;
    margin-right: 4px !important;
  }
}

/* Sidebar Menu Scrollbar */
.sidebar {
  display: flex !important;
  flex-direction: column !important;
  max-height: 100vh !important;
  overflow: hidden !important;
}

.sidebar .sidebar-inner,
.sidebar #sidebar-menu,
#scrollbar {
  overflow-y: auto !important;
  overflow-x: hidden !important;
  scrollbar-width: thin;
  scrollbar-color: #FE9F43 #f1f1f1;
}

.sidebar .sidebar-inner {
  flex: 1 1 auto !important;
  height: calc(100vh - 65px) !important;
  max-height: calc(100vh - 65px) !important;
}

/* Chrome, Edge, Safari Webkit scrollbar styling */
.sidebar .sidebar-inner::-webkit-scrollbar,
.sidebar #sidebar-menu::-webkit-scrollbar,
#scrollbar::-webkit-scrollbar {
  width: 6px;
}

.sidebar .sidebar-inner::-webkit-scrollbar-track,
.sidebar #sidebar-menu::-webkit-scrollbar-track,
#scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.sidebar .sidebar-inner::-webkit-scrollbar-thumb,
.sidebar #sidebar-menu::-webkit-scrollbar-thumb,
#scrollbar::-webkit-scrollbar-thumb {
  background: #FE9F43;
  border-radius: 4px;
}

.sidebar .sidebar-inner::-webkit-scrollbar-thumb:hover,
.sidebar #sidebar-menu::-webkit-scrollbar-thumb:hover,
#scrollbar::-webkit-scrollbar-thumb:hover {
  background: #e08e3a;
}

/* ============================================================
   TABLET & RESPONSIVE LAYOUT ENHANCEMENTS (768px - 1024px)
   ============================================================ */

/* 1. Header & Navigation for Tablets */
@media (min-width: 768px) and (max-width: 1024px) {
  /* Override template rule that hides .user-menu on <= 991px */
  .header .user-menu {
    display: flex !important;
    align-items: center;
    gap: 6px;
    margin: 0;
    padding-right: 14px;
    height: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .header .user-menu::-webkit-scrollbar {
    display: none;
  }

  /* Hide the 3-dots mobile dropdown on tablet since user-menu is active */
  .header .mobile-user-menu {
    display: none !important;
  }

  /* Allow header-left to shrink and not take 100% absolute width */
  .header .header-left,
  .header.pos-header .header-left {
    position: relative !important;
    width: auto !important;
    flex-shrink: 0;
  }

  /* Compact button styling in user-menu */
  .header .user-menu > li {
    margin-left: 6px !important;
    flex-shrink: 0;
  }

  .header .user-menu .btn {
    padding: 6px 10px !important;
    font-size: 13px !important;
    white-space: nowrap;
  }

  .header .user-menu .nav-item-box > a {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Compact search input */
  .header .user-menu .nav-searchinputs {
    max-width: 220px;
    flex-shrink: 1;
  }

  .header .top-nav-search form {
    display: block !important;
  }

  .header .top-nav-search form .searchinputs input {
    width: 150px !important;
    padding: 6px 30px 6px 10px !important;
    font-size: 12px !important;
    height: 36px !important;
  }

  /* Hide session/company text in header to prevent crowding on tablet */
  .header .user-menu .company-name {
    display: none !important;
  }

  /* Compact Tally button text */
  .tally-btn-full,
  .tally-sync-full {
    display: none !important;
  }
  .tally-btn-compact,
  .tally-sync-compact {
    display: inline !important;
  }
}

/* Also on screens under 1200px, hide company-name in header to prevent wrapping */
@media (max-width: 1199.98px) {
  .header .user-menu .company-name {
    display: none !important;
  }
}

/* 2. POS Billing Screen Responsiveness */
@media (min-width: 768px) and (max-width: 991.98px) {
  .pos-products-section {
    flex: 0 0 58% !important;
    max-width: 58% !important;
  }
  .pos-cart-section {
    flex: 0 0 42% !important;
    max-width: 42% !important;
  }
  .pos-products .tab_content {
    max-height: calc(100vh - 160px);
    overflow-y: auto;
    padding-right: 6px;
  }
}

/* POS Cart item scroll on all devices */
.pos-cart-items-scroll {
  scrollbar-width: thin;
  scrollbar-color: #FE9F43 #f1f1f1;
}

/* 3. Card Headers, Filter Forms & Table Responsiveness */
@media (max-width: 1024px) {
  .card-header.d-flex {
    flex-wrap: wrap !important;
    gap: 10px !important;
  }

  /* Prevent filter inputs from squeezing */
  .card-header .row.g-2 > [class*="col-"] {
    margin-bottom: 6px;
  }

  /* Responsive pills/tabs */
  .nav-pills.tab-style-5 {
    flex-wrap: wrap !important;
    gap: 8px !important;
  }
  .nav-pills.tab-style-5 .nav-item {
    flex: 1 1 auto;
    min-width: 130px;
  }

  /* Ensure react-data-table has smooth horizontal scroll and isn't clipped */
  .rdt_Table {
    min-width: 100% !important;
  }

  div[class*="rdt_Table"] {
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
  }

  .rdt_Pagination {
    flex-wrap: wrap !important;
    justify-content: center !important;
    gap: 8px;
    padding: 8px 12px !important;
  }
}

/* Touch-friendly buttons and inputs on tablets */
@media (min-width: 768px) and (max-width: 1024px) {
  .btn {
    min-height: 36px;
  }
  .table td, .table th {
    padding: 8px 6px;
  }
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE;MACI,kCAAkC;EACtC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;;;;AAKA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;;AAE3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB,EAAE,wBAAwB;EAC/C,iBAAiB;EACjB,mBAAmB;AACrB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;;AAEjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;;AAGA,wDAAwD;AACxD;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;EACA;IACE,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;;AAGA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;;AAGA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,OAAO;IACP,0BAA0B;AAC9B;;;AAGA;;iEAEiE;;AAEjE;;EAEE,yBAAyB;EACzB,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,2CAA2C;EAC3C,oDAAoD;EACpD,uBAAuB;EACvB,oBAAoB;EACpB,0BAA0B;EAC1B,iCAAiC;EACjC,8BAA8B;EAC9B,qBAAqB;EACrB,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA,uEAAuE;AACvE;EACE;;IAEE,sBAAsB;IACtB,oCAAoC;EACtC;;EAEA;;IAEE,qBAAqB;IACrB,mCAAmC;EACrC;AACF;;AAEA;uEACuE;AACvE;EACE;;;IAGE,yBAAyB;IACzB,0BAA0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;IAC9B,qBAAqB;IACrB,0BAA0B;EAC5B;AACF;;AAEA;EACE;;;IAGE,uBAAuB;IACvB,yBAAyB;EAC3B;AACF;;AAEA,uCAAuC;AACvC;;EAEE,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,sCAAsC;AACtC;;EAEE,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,4CAA4C;EAC5C,gCAAgC,EAAE,YAAY;AAChD;;AAEA;;EAEE,wBAAwB,EAAE,2BAA2B;AACvD;;AAEA;;EAEE,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;;EAEE,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;EAEE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;;IAEE,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;IAC1B,4BAA4B;EAC9B;AACF;;AAEA,2BAA2B;AAC3B;EACE,wBAAwB;EACxB,iCAAiC;EACjC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;;;EAGE,2BAA2B;EAC3B,6BAA6B;EAC7B,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA,kDAAkD;AAClD;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;iEAEiE;;AAEjE,uCAAuC;AACvC;EACE,6DAA6D;EAC7D;IACE,wBAAwB;IACxB,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;;EAEA,wEAAwE;EACxE;IACE,wBAAwB;EAC1B;;EAEA,iEAAiE;EACjE;;IAEE,6BAA6B;IAC7B,sBAAsB;IACtB,cAAc;EAChB;;EAEA,wCAAwC;EACxC;IACE,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,yBAAyB;EACzB;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,qCAAqC;IACrC,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA,sEAAsE;EACtE;IACE,wBAAwB;EAC1B;;EAEA,8BAA8B;EAC9B;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA,kFAAkF;AAClF;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;EACA;IACE,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,wCAAwC;AACxC;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA,yDAAyD;AACzD;EACE;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA,yCAAyC;EACzC;IACE,kBAAkB;EACpB;;EAEA,0BAA0B;EAC1B;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA,2EAA2E;EAC3E;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;IAC3B,4CAA4C;EAC9C;;EAEA;IACE,0BAA0B;IAC1B,kCAAkC;IAClC,QAAQ;IACR,4BAA4B;EAC9B;AACF;;AAEA,iDAAiD;AACjD;EACE;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".modal {\n  background: #0000006e;\n}\n\n.bg-grey { \n  background-color: #bbbbbb !important;\n}\n\n.user-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n@media (min-width: 992px) {\n  .modal-lg, .modal-xl {\n      --vz-modal-width: 960px !important;\n  }\n}\n\n.user-card {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: 0.3s;\n  min-width: 200px;\n}\n\n.user-card:hover {\n  background: #f5f5f5;\n}\n\n.user-card.selected {\n  border: 2px solid #007bff;\n  background: rgba(0, 123, 255, 0.1);\n}\n\n.user-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.user-info {\n  flex-grow: 1;\n}\n\n.select-icon {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n\n\n\n#quoteDetail .container {\n  width: 80%;\n  margin: auto;\n  padding: 20px;\n  border: 1px solid #000;\n}\n#quoteDetail .header, .footer {\n  text-align: center;\n  font-weight: bold;\n  page-break-before: always;\n\n}\n#quoteDetail .details, .terms {\n  margin-top: 20px;\n}\n#quoteDetail table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n#quoteDetail table, th, td {\n  border: 1px solid black;\n  padding: 8px;\n  text-align: left;\n}\n#quoteDetail .right {\n  text-align: right;\n}\n\n#quoteDetail td,#quoteDetail th,#quoteDetail p,#quoteDetail div {\n  letter-spacing: 0.5px; /* Adjust if necessary */\n  word-spacing: 1px;\n  white-space: normal;\n}\n\n\n.form-check-input {\n  width: 50px;\n  height: 24px;\n  background-color: #ccc;\n  border-radius: 24px;\n  position: relative;\n  margin-right: 3px;\n  appearance: none;\n  -webkit-appearance: none;\n  outline: none;\n  transition: background-color 0.3s;\n  cursor: pointer;\n}\n\n.form-check-input::before {\n  content: '';\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  background: #fff;\n  border-radius: 50%;\n  top: 3px;\n  left: 3px;\n  transition: transform 0.3s;\n}\n\n.form-check-input:checked {\n  background-color: #4caf50;\n}\n\n.form-check-input:checked::before {\n  transform: translateX(20px);\n}\n\n.form-check {\n  display: flex;\n  align-items: center;\n  gap: 1px;\n  margin-right: 30px !important;\n}\n\n.form-check-label {\n  margin-bottom: 0;\n  font-weight: 500;\n  margin-top: 5px;\n\n}\n\n.navbar-menu {\n  background: #1b1b1f;\n}\n\n.scanner-box {\n  width: 100%;\n  max-width: 800px;\n  height: 350px;\n  border: 2px solid #333;\n  border-radius: 8px;\n  overflow: hidden;\n  position: relative;\n  background: #000;\n  margin: 0 auto;\n}\n\n@media (max-width: 768px) {\n  .scanner-box {\n    height: 160px;\n  }\n}\n\n\n/* Page Wrapper Padding with / without Horizontal Menu */\n.page-wrapper.has-horizontal-menu {\n  padding-top: 122px !important;\n}\n\n.page-wrapper.no-menu-padding {\n  padding: 65px 0 0 !important;\n}\n\n@media (max-width: 991.96px) {\n  .page-wrapper.has-horizontal-menu {\n    padding-top: 122px !important;\n    margin-left: 0 !important;\n  }\n  .page-wrapper.no-menu-padding {\n    padding: 65px 0 0 !important;\n    margin-left: 0 !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .page-wrapper.has-horizontal-menu {\n    padding-top: 118px !important;\n  }\n}\n\n.slide-form {\n  max-width: 0;\n  opacity: 0;\n  overflow: hidden;\n  transition: all 0.35s ease;\n}\n\n.slide-form.open {\n  max-width: 100%;\n  opacity: 1;\n}\n\n\n.spin {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n\n.dropdown-fixed {\n    margin-top: 0 !important;\n    top: 100% !important;\n    left: 0;\n    transform: translateY(2px);\n}\n\n\n/* ============================================================\n   HORIZONTAL SUB-NAVIGATION (DESKTOP & RESPONSIVE)\n   ============================================================ */\n\n#horizontal-menu,\n.horizontal-menu-wrapper {\n  display: block !important;\n  position: fixed !important;\n  top: 65px !important;\n  right: 0 !important;\n  height: 52px !important;\n  background: #ffffff !important;\n  border-bottom: 1px solid #e6eaed !important;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04) !important;\n  z-index: 998 !important;\n  margin: 0 !important;\n  padding: 0 16px !important;\n  box-sizing: border-box !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n  pointer-events: auto !important;\n  transition: left 0.3s ease, width 0.3s ease;\n}\n\n/* Desktop layout (width > 991.96px): offset by left vertical sidebar */\n@media (min-width: 992px) {\n  #horizontal-menu,\n  .horizontal-menu-wrapper {\n    left: 252px !important;\n    width: calc(100% - 252px) !important;\n  }\n\n  .mini-sidebar #horizontal-menu,\n  .mini-sidebar .horizontal-menu-wrapper {\n    left: 80px !important;\n    width: calc(100% - 80px) !important;\n  }\n}\n\n/* Responsive mode (Tablets & Mobile <= 991.96px):\n   Ensure menu is fully visible across full screen width under header */\n@media (max-width: 991.96px) {\n  #horizontal-menu,\n  .horizontal-menu-wrapper,\n  .sidebar-horizontal {\n    display: block !important;\n    position: fixed !important;\n    top: 65px !important;\n    left: 0 !important;\n    right: 0 !important;\n    width: 100% !important;\n    margin-left: 0 !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n    padding: 0 12px !important;\n  }\n}\n\n@media (max-width: 768px) {\n  #horizontal-menu,\n  .horizontal-menu-wrapper,\n  .sidebar-horizontal {\n    height: 48px !important;\n    padding: 0 8px !important;\n  }\n}\n\n/* Inner structure of Horizontal Menu */\n#horizontal-menu .sidebar-menu,\n.horizontal-menu-wrapper .sidebar-menu {\n  height: 100% !important;\n  width: 100% !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n#horizontal-menu .horizontal-scroll-wrapper,\n.horizontal-menu-wrapper .horizontal-scroll-wrapper {\n  width: 100% !important;\n  height: 100% !important;\n  display: flex !important;\n  align-items: center !important;\n  overflow: hidden !important;\n  position: relative !important;\n}\n\n/* Horizontally scrollable pill list */\n#horizontal-menu .horizontal-scroll-menu,\n.horizontal-menu-wrapper .horizontal-scroll-menu {\n  display: flex !important;\n  flex-direction: row !important;\n  flex-wrap: nowrap !important;\n  align-items: center !important;\n  gap: 8px !important;\n  width: 100% !important;\n  height: 100% !important;\n  margin: 0 !important;\n  padding: 4px 2px !important;\n  list-style: none !important;\n  overflow-x: auto !important;\n  -webkit-overflow-scrolling: touch !important;\n  scrollbar-width: none !important; /* Firefox */\n}\n\n#horizontal-menu .horizontal-scroll-menu::-webkit-scrollbar,\n.horizontal-menu-wrapper .horizontal-scroll-menu::-webkit-scrollbar {\n  display: none !important; /* Chrome / Safari / Edge */\n}\n\n#horizontal-menu .horizontal-scroll-menu li,\n.horizontal-menu-wrapper .horizontal-scroll-menu li {\n  flex-shrink: 0 !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  white-space: nowrap !important;\n}\n\n/* Pill buttons */\n#horizontal-menu .horizontal-scroll-menu .btn,\n.horizontal-menu-wrapper .horizontal-scroll-menu .btn {\n  display: inline-flex !important;\n  align-items: center !important;\n  padding: 6px 14px !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  line-height: 1.2 !important;\n  border-radius: 6px !important;\n  white-space: nowrap !important;\n  transition: all 0.2s ease !important;\n  text-decoration: none !important;\n}\n\n#horizontal-menu .horizontal-scroll-menu .btn i,\n.horizontal-menu-wrapper .horizontal-scroll-menu .btn i {\n  font-size: 15px !important;\n  margin-right: 6px !important;\n}\n\n@media (max-width: 768px) {\n  #horizontal-menu .horizontal-scroll-menu {\n    gap: 6px !important;\n  }\n\n  #horizontal-menu .horizontal-scroll-menu .btn,\n  .horizontal-menu-wrapper .horizontal-scroll-menu .btn {\n    padding: 5px 10px !important;\n    font-size: 12px !important;\n  }\n\n  #horizontal-menu .horizontal-scroll-menu .btn i,\n  .horizontal-menu-wrapper .horizontal-scroll-menu .btn i {\n    font-size: 14px !important;\n    margin-right: 4px !important;\n  }\n}\n\n/* Sidebar Menu Scrollbar */\n.sidebar {\n  display: flex !important;\n  flex-direction: column !important;\n  max-height: 100vh !important;\n  overflow: hidden !important;\n}\n\n.sidebar .sidebar-inner,\n.sidebar #sidebar-menu,\n#scrollbar {\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n  scrollbar-width: thin;\n  scrollbar-color: #FE9F43 #f1f1f1;\n}\n\n.sidebar .sidebar-inner {\n  flex: 1 1 auto !important;\n  height: calc(100vh - 65px) !important;\n  max-height: calc(100vh - 65px) !important;\n}\n\n/* Chrome, Edge, Safari Webkit scrollbar styling */\n.sidebar .sidebar-inner::-webkit-scrollbar,\n.sidebar #sidebar-menu::-webkit-scrollbar,\n#scrollbar::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sidebar .sidebar-inner::-webkit-scrollbar-track,\n.sidebar #sidebar-menu::-webkit-scrollbar-track,\n#scrollbar::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.sidebar .sidebar-inner::-webkit-scrollbar-thumb,\n.sidebar #sidebar-menu::-webkit-scrollbar-thumb,\n#scrollbar::-webkit-scrollbar-thumb {\n  background: #FE9F43;\n  border-radius: 4px;\n}\n\n.sidebar .sidebar-inner::-webkit-scrollbar-thumb:hover,\n.sidebar #sidebar-menu::-webkit-scrollbar-thumb:hover,\n#scrollbar::-webkit-scrollbar-thumb:hover {\n  background: #e08e3a;\n}\n\n/* ============================================================\n   TABLET & RESPONSIVE LAYOUT ENHANCEMENTS (768px - 1024px)\n   ============================================================ */\n\n/* 1. Header & Navigation for Tablets */\n@media (min-width: 768px) and (max-width: 1024px) {\n  /* Override template rule that hides .user-menu on <= 991px */\n  .header .user-menu {\n    display: flex !important;\n    align-items: center;\n    gap: 6px;\n    margin: 0;\n    padding-right: 14px;\n    height: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n  }\n  .header .user-menu::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Hide the 3-dots mobile dropdown on tablet since user-menu is active */\n  .header .mobile-user-menu {\n    display: none !important;\n  }\n\n  /* Allow header-left to shrink and not take 100% absolute width */\n  .header .header-left,\n  .header.pos-header .header-left {\n    position: relative !important;\n    width: auto !important;\n    flex-shrink: 0;\n  }\n\n  /* Compact button styling in user-menu */\n  .header .user-menu > li {\n    margin-left: 6px !important;\n    flex-shrink: 0;\n  }\n\n  .header .user-menu .btn {\n    padding: 6px 10px !important;\n    font-size: 13px !important;\n    white-space: nowrap;\n  }\n\n  .header .user-menu .nav-item-box > a {\n    width: 36px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* Compact search input */\n  .header .user-menu .nav-searchinputs {\n    max-width: 220px;\n    flex-shrink: 1;\n  }\n\n  .header .top-nav-search form {\n    display: block !important;\n  }\n\n  .header .top-nav-search form .searchinputs input {\n    width: 150px !important;\n    padding: 6px 30px 6px 10px !important;\n    font-size: 12px !important;\n    height: 36px !important;\n  }\n\n  /* Hide session/company text in header to prevent crowding on tablet */\n  .header .user-menu .company-name {\n    display: none !important;\n  }\n\n  /* Compact Tally button text */\n  .tally-btn-full,\n  .tally-sync-full {\n    display: none !important;\n  }\n  .tally-btn-compact,\n  .tally-sync-compact {\n    display: inline !important;\n  }\n}\n\n/* Also on screens under 1200px, hide company-name in header to prevent wrapping */\n@media (max-width: 1199.98px) {\n  .header .user-menu .company-name {\n    display: none !important;\n  }\n}\n\n/* 2. POS Billing Screen Responsiveness */\n@media (min-width: 768px) and (max-width: 991.98px) {\n  .pos-products-section {\n    flex: 0 0 58% !important;\n    max-width: 58% !important;\n  }\n  .pos-cart-section {\n    flex: 0 0 42% !important;\n    max-width: 42% !important;\n  }\n  .pos-products .tab_content {\n    max-height: calc(100vh - 160px);\n    overflow-y: auto;\n    padding-right: 6px;\n  }\n}\n\n/* POS Cart item scroll on all devices */\n.pos-cart-items-scroll {\n  scrollbar-width: thin;\n  scrollbar-color: #FE9F43 #f1f1f1;\n}\n\n/* 3. Card Headers, Filter Forms & Table Responsiveness */\n@media (max-width: 1024px) {\n  .card-header.d-flex {\n    flex-wrap: wrap !important;\n    gap: 10px !important;\n  }\n\n  /* Prevent filter inputs from squeezing */\n  .card-header .row.g-2 > [class*=\"col-\"] {\n    margin-bottom: 6px;\n  }\n\n  /* Responsive pills/tabs */\n  .nav-pills.tab-style-5 {\n    flex-wrap: wrap !important;\n    gap: 8px !important;\n  }\n  .nav-pills.tab-style-5 .nav-item {\n    flex: 1 1 auto;\n    min-width: 130px;\n  }\n\n  /* Ensure react-data-table has smooth horizontal scroll and isn't clipped */\n  .rdt_Table {\n    min-width: 100% !important;\n  }\n\n  div[class*=\"rdt_Table\"] {\n    overflow-x: auto !important;\n    -webkit-overflow-scrolling: touch !important;\n  }\n\n  .rdt_Pagination {\n    flex-wrap: wrap !important;\n    justify-content: center !important;\n    gap: 8px;\n    padding: 8px 12px !important;\n  }\n}\n\n/* Touch-friendly buttons and inputs on tablets */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .btn {\n    min-height: 36px;\n  }\n  .table td, .table th {\n    padding: 8px 6px;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
